"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.events = void 0;
exports.events = ["onMouseDown", "onScroll", "onInput", "onClick", "onKeyUp", "onKeyDown", "onFocus", "onImageUploadBefore", "onVideoUploadBefore", "onAudioUploadBefore", "onImageUpload", "onAudioUpload", "onVideoUpload", "onImageUploadError", "onVideoUploadError", "onAudioUploadError", "onSave", "onSetToolbarButtons", "imageUploadHandler", "toggleCodeView", "toggleFullScreen", "showInline", "showController"];